<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.show_offer") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Offer Basic Info -->
          <div class="col-12 my-4">
            <h5 class="text-primary mb-3">
              {{ $t("PLACEHOLDERS.offer_details") }}
            </h5>
          </div>

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.discount_percentage')"
            :value="data.discount + '%'"
            disabled
          />

          <base-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.start_date')"
            v-model.trim="data.start_date"
            disabled
          />

          <base-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.end_date')"
            v-model.trim="data.end_date"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.offer_status')"
            v-model.trim="data.status"
            disabled
          />

          <base-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.created_at')"
            v-model.trim="data.created_at"
            disabled
          />
          <!-- End:: Offer Basic Info -->

          <!-- Start:: Product Details Section -->
          <div class="col-12 my-4">
            <h5 class="text-primary mb-3">
              {{ $t("PLACEHOLDERS.product_details") }}
            </h5>
          </div>

          <!-- Start:: Product Images -->
          <div class="col-12 mb-4">
            <div class="preview-container text-center my-3">
              <img
                :src="data.product.main_image"
                alt="Product Image"
                v-if="data.product.main_image"
                class="main-product-image"
              />
            </div>
            <!-- Additional Images -->
            <div
              class="additional-images d-flex flex-wrap gap-2 justify-center"
              v-if="data.product.images && data.product.images.length"
            >
              <img
                v-for="image in data.product.images"
                :key="image.id"
                :src="image.url"
                alt="Product Image"
                class="additional-image"
                @click="showImageModal(image.url)"
              />
            </div>
          </div>
          <!-- End:: Product Images -->

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.productName')"
            v-model.trim="data.product.name"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.brand')"
            v-model.trim="data.product.brand.name"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.main_category')"
            v-model.trim="data.product.sub_category.category.name"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.sub_section')"
            v-model.trim="data.product.sub_category.name"
            disabled
          />

          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.price')"
            v-model.trim="data.product.price"
            disabled
          />

          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.discounted_price')"
            v-model.trim="data.product.price_after_discount"
            disabled
          />
          <!-- End:: Product Details Section -->

          <!-- Start:: Package Details Section -->
          <div class="col-12 my-4">
            <h5 class="text-primary mb-3">
              {{ $t("PLACEHOLDERS.package_details") }}
            </h5>
          </div>

          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.number_of_units')"
            v-model.trim="data.product.number_of_units"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.unit_weight')"
            v-model.trim="data.product.unit_weight"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.measurement_unit')"
            v-model.trim="data.product.measurement_unit"
            disabled
          />
          <!-- End:: Package Details Section -->

          <!-- Start:: Offer Duration Section -->
          <div class="col-12 my-4" v-if="data.product.active_offer">
            <h5 class="text-success mb-3">
              {{ $t("PLACEHOLDERS.offer_duration") }}
            </h5>
          </div>

          <base-input
            v-if="data.product.active_offer"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.remaining_days')"
            :value="
              data.product.active_offer.number_of_remaining_days +
              ' ' +
              $t('PLACEHOLDERS.days')
            "
            disabled
          />
          <!-- End:: Offer Duration Section -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->

    <!-- Start:: Image Modal -->
    <v-dialog v-model="dialogImage" max-width="800">
      <v-card>
        <v-card-text class="text-center">
          <img
            :src="selectedImage"
            alt="Product Image"
            style="max-width: 100%; max-height: 70vh"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogImage = false">{{
            $t("BUTTONS.close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End:: Image Modal -->
  </div>
</template>

<script>
export default {
  name: "ShowOffer",

  
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        id: null,
        discount: null,
        start_date: null,
        end_date: null,
        status_enum: null,
        status: null,
        is_active: null,
        created_at: null,
        product: {
          id: null,
          name: null,
          main_image: null,
          images: [],
          number_of_units: null,
          unit_weight: null,
          measurement_unit: null,
          price: null,
          price_after_discount: null,
          amount: null,
          cart_quantity: null,
          is_active: null,
          created_at: null,
          sub_category: {
            id: null,
            name: null,
            image: null,
            category: {
              id: null,
              name: null,
              image: null,
            

},
          },
          brand: {
            id: null,
            name: null,
            image: null,
          },
          user: {
            id: null,
            name: null,
            avatar: null,
          },
          active_offer: null,
        },
      },
      // End:: Data Collection To Send

      // Start:: Dialog Control
      dialogImage: false,
      selectedImage: null,
      // End:: Dialog Control
    };
  },

  computed: {},

  methods: {
    // Start:: Show Image Modal
    showImageModal(imageUrl) {
      this.selectedImage = imageUrl;
      this.dialogImage = true;
    },
    // End:: Show Image Modal

    // start show data
    async showOffer() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `offers/${this.$route.params.id}`,
        });

        const offerData = res.data.data.data;

        // Set offer basic data
        this.data.id = offerData.id;
        this.data.discount = offerData.discount;
        this.data.start_date = offerData.start_date;
        this.data.end_date = offerData.end_date;
        this.data.status_enum = offerData.status_enum;
        this.data.status = offerData.status;
        this.data.is_active = offerData.is_active;
        this.data.created_at = offerData.created_at;

        // Set product data
        this.data.product = offerData.product;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end show data
  },

  created() {
    // Start:: Fire Methods
    this.showOffer();
    // End:: Fire Methods
  },
};
</script>
<style scoped>
.preview-container img,
.preview-container video {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 8px;
}

.main-product-image {
  max-width: 100%;
  max-height: 300px;
  border: 2px solid #3eb6d4;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.additional-images {
  margin-top: 20px;
}

.additional-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.additional-image:hover {
  border-color: #3eb6d4;
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(61, 95, 255, 0.3);
}

.gap-2 {
  gap: 8px;
}
</style>
